import autoTable from "jspdf-autotable";
import { drawGrandTotal } from "./iohdrawGrandTotalpdf";
import { format } from "crypto-js";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;

    function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}



  const columnStyles = {
    0: { cellWidth: 30, halign: "right" },
    1: { cellWidth: 30, halign: "right" },
    2: { cellWidth: 50, halign: "right" },
    3: { cellWidth: 45, halign: "right" },
     4: { cellWidth: 40, halign: "right" },
      5: { cellWidth: 40, halign: "right" },
       6: { cellWidth: 40, halign: "right" },
      
  };

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

  // ================= HEADER =================
  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_GROUP);
  doc.rect(14, startY - 10, 275, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_GROUP);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_GROUP);
  doc.text(` ${shop} Railway`, 20, startY - 5);

  // ================= DETAIL TABLE =================
  autoTable(doc, {
    startY,
...PDF_TABLE_STYLE,
    head: [[
      "Zonal Railway	",
      "Type of Trolly",
      "No of Trolly",
      "Coach Set",
      "Labour Cost",
      "Material Cost",
      "Total Cost",
    ]],

    body: rows.map((r) => [
      (r.rail),
      (r.trolly_type),
      format(r.nooftrolly),
      format(r.coachset),
      format(r.labourcost),
      format(r.materialcost),
      format(r.totalcost),
    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,
  });

  // ================= DEPOT TOTAL =================
  const y = doc.lastAutoTable.finalY + 2;

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_TOTAL);
  doc.rect(14, y, 275, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_TOTAL);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_TOTAL);

  // Depot Total text
  doc.text(`${String(shop).trim()} TOTAL`, 16, y + 5);

  // Debit Total
  doc.text(format(total.nooftrolly), 122, y + 5, {
    align: "right",
  });

  // Credit Total
  doc.text(format(total.coachset) , 168, y + 5, {
    align: "right",
  });

  // Labour Cost Total
  doc.text(format(total.labourcost), 208, y + 5, {
    align: "right",
  });

  // Material Cost Total
  doc.text(format(total.materialcost), 248, y + 5, {
    align: "right",
  });

  // Total Cost Total
  doc.text(format(total.totalcost), 286, y + 5, {
    align: "right",
  });

  // Reset text color
  doc.setTextColor(0);

// Reserve space after Depot Total
doc.lastAutoTable.finalY = y +  5;
//                 rectangle height ^   ^ extra space
}



